import {
    ADD_CHATEVENT,
    UPDATE_CHATEVENT,
    REPORT_ERROR,
    CHAT_RESET,
    SET_REGISTRATION,
    SET_AGENT,
    SET_AGENTTYPING,
    SET_SESSIONACTIVE,
    MARK_ALL_READ,
    SET_CHATSTATE,
    SET_MESSAGEINPUT,
    SHOW_OPTIONS,
    SET_FILE_LIMITS,
    SET_OFF_TOPIC,
    SET_MONITOR_FOR_USER_MO_LOGIN,
    SET_INPUT_MASK
} from '../../../helpers/action-types';
import { CHAT } from './types';
import store from '../../../helpers/store';
import { VIEWS, VIEW_MODES } from '../types';
import { APIMode, APISubmode } from '../../../api/types';
import Logger from '../../../../common/logger';
import * as WidgetActions from '../../layers/widget/actions';

export const CHAT_STATE = {
    NOT_STARTED: 'notstarted',
    RUNNING: 'running',
    FINISHED: 'finished'
};

export const MESSAGE_TYPE = {
    WELCOME: 'Welcome',
    AGENT_JOINED: 'AgentJoined',
    AGENT_LEFT: 'AgentLeft',
    CUSTOMMESSAGE: 'CustomMessage',
    MESSAGE: 'Message',
    BOT_MESSAGE: 'BotMessage',
    AGENT_TYPING: 'AgentTyping',
    SESSION_END: 'SessionEnd',
    TRANSFER: 'Transfer',
    FILE_UPLOADED: 'FileUploaded',
    PROMO: 'Promo',
    BUTTONS: 'Buttons',
    ADDRESS_FORM: 'AddressForm'
};

export function addChatEvent(message) {
    return {
        type: ADD_CHATEVENT,
        message
    };
}

export function updateChatEvent(message) {
    return {
        type: UPDATE_CHATEVENT,
        message
    };
}

export function reportError(error) {
    return {
        type: REPORT_ERROR,
        error
    };
}

export function markAllEventsAsRead() {
    return {
        type: MARK_ALL_READ
    };
}

export function reset() {
    return {
        type: CHAT_RESET
    };
}

export function setRegistration(registration) {
    return {
        type: SET_REGISTRATION,
        registration
    };
}

export function setAgent(available, name = null) {
    return {
        type: SET_AGENT,
        available,
        name
    };
}

export function setAgentTyping(agentTyping) {
    return {
        type: SET_AGENTTYPING,
        agentTyping
    };
}

export function setSessionActive(sessionActive) {
    return {
        type: SET_SESSIONACTIVE,
        sessionActive
    };
}

export function setChatState(state) {
    return {
        type: SET_CHATSTATE,
        state
    };
}

export function setMessageInput(messageInput) {
    return {
        type: SET_MESSAGEINPUT,
        messageInput
    };
}

export function setAPIMode(mode) {
    return {
        type: CHAT.SET_API_MODE,
        mode
    };
}

export function setAPISubmode(submode) {
    return {
        type: CHAT.SET_API_SUBMODE,
        submode: submode
    };
}

export function showOptions(options) {
    return {
        type: SHOW_OPTIONS,
        options
    };
}

export function setFileLimits(fileLimits) {
    return {
        type: SET_FILE_LIMITS,
        fileLimits
    };
}

export const onDocumentClick = () => {
    const state = store.getState();
    if (
        state.widget?.currentView !== VIEWS.CHAT ||
        state.widget?.currentMode !== VIEW_MODES.MAXIMIZED
    ) {
        return;
    }

    if (
        state.config.widget.chatOptions.registration &&
        (!state.config.widget.chatOptions.registration || !state.chat.registration.registered)
    ) {
        return;
    }

    Logger.log('DocumentClick');
    store.dispatch(markAllEventsAsRead());
    WidgetActions.onMinimize();
};

export const setOffTopic = (messageText) => {
    const state = store.getState();
    if (
        state.chat.mode === APIMode.CHAT &&
        state.chat.submode !== APISubmode.MAX &&
        messageText.match(/orange.pl\/zaloguj.phtml/)
    ) {
        store.dispatch({
            type: SET_OFF_TOPIC,
            isOffTopic: true
        });
    }
};

export const setMonitorForUserMOLogin = (doMonitor) => {
    store.dispatch({
        type: SET_MONITOR_FOR_USER_MO_LOGIN,
        doMonitor: doMonitor
    });
};

export const setInputMask = (mask) => {
    store.dispatch({
        type: SET_INPUT_MASK,
        mask: mask
    });
    store.dispatch({
        type: SET_MESSAGEINPUT,
        messageInput: ''
    });
};
